__webpack_require__.p = "https://ted.consulting/";